<template>
  <div class="right-container">
    <div class="right-header flex-between">
      <div class="flex-row-start">
        <a
          href="javascript:;"
          class="sign column"
          :class="{ active: stageIng.id == item.id }"
          v-for="(item, index) in stageList"
          :key="index"
          @click="onSelectTab(item)"
          >{{ item.name }}</a
        >
      </div>
      <div class="flex-row-end">
        <div class="circle"></div>
        <div class="right-header-text">
          当前错题总数：<span class="num">{{ countTotal }}</span>
        </div>
      </div>

      <div class="subject-box">
        <a
          class="subject-list"
          href="javascript:;"
          v-for="(n, k) in subjectList"
          :key="k"
          :class="{ subjectEd: subjectIng.id == n.id }"
          @click="onSubject(n)"
          >{{ n.name }}</a
        >
      </div>
    </div>
    <div class="knowledge-box flex-between">
      <div class="knowledge-left knowledge flex-between">
        <div class="knowledge-title">
          <span>最近做错的知识点:</span>
          <img
            src="../../assets/images/error_top10.png"
            class="top-img"
            alt=""
          />
        </div>
        <div class="knowledge-scrollbars">
          <div
            class="knowledge-list flex-between"
            v-for="(n, i) in newKnowledgeCodeList"
            :key="i"
          >
            <div class="knowledge-text">{{ n.knowledge_name }}</div>
            <div class="knowledge-button flex-row">
              <span class="knowledge-looks-error" @click="onKnowledge(n)"
                >查看错题</span
              >
              <span class="redo-error" @click="onRedoError(n)">重做错题</span>
            </div>
          </div>
        </div>
      </div>
      <div class="knowledge-right knowledge flex-between">
        <div class="knowledge-title">
          <span>最常犯错的知识点:</span>
          <img
            src="../../assets/images/error_top10.png"
            class="top-img"
            alt=""
          />
        </div>
        <div class="knowledge-scrollbars">
          <div
            class="knowledge-list flex-between"
            v-for="(val, key) in mostKnowledgeCodeList"
            :key="key"
          >
            <div class="knowledge-text">{{ val.knowledge_name }}</div>
            <div class="knowledge-button flex-row">
              <span class="knowledge-looks-error" @click="onKnowledge(val)"
                >查看错题</span
              >
              <span class="redo-error" @click="onRedoError(val)">重做错题</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="count-box flex-between">
      <div>
        当前分类：<span class="text-color"
          >{{ stageIng.name }}-{{ subjectIng.name
          }}<span v-if="knowledgeIng.knowledge_name"
            >-{{ knowledgeIng.knowledge_name }}</span
          ></span
        >
      </div>
      <div>
        错题数量：<span class="text-color">{{ pageTotal }}</span>
      </div>
    </div>
    <div class="list-container" id="question-list" v-if="isNull">
      <div
        class="error-list flex-between"
        v-for="(item, index) in errorList"
        :key="index"
      >
        <div class="error-list-left">
          <div v-html="item.question.topic"></div>
          <div
            v-html="item.question.subtitle"
            v-if="item.question.subtitle"
          ></div>
          <!-- <div
            v-if="item.exercise.children.length > 0"
            v-html="item.exercise.children[0].context.stem"
          ></div> -->
        </div>

        <div class="error-list-right">
          <div class="error-list-right-top" @click="onExercise(item)">
            错题详情
          </div>
          <div class="error-list-right-bottom" @click="onDelete(item)">
            删除错题
          </div>
        </div>
      </div>
      <div class="clearfix list-page">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.page"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="list-container column" v-else>
      <img src="../../assets/images/list_null.png" alt="" srcset="" />
      <div class="null">暂无数据~~</div>
    </div>

    <el-dialog
      class="dialog dialog-exercise"
      title="错题详情"
      :visible.sync="dialogStatus"
      width="895px"
    >
      <div class="dialog-looks-Answer">
        <zi-hui-xue-looks-answer-exercise
          :isTabShow="true"
          :index="0"
          :exerciseList="exerciseListData"
        ></zi-hui-xue-looks-answer-exercise>
      </div>
    </el-dialog>
    <el-dialog
      class="rode-dialog"
      :visible.sync="isRedo"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <rode ref="rodeRef" :list="redoList" :knowledgeName="redoKnowledgeName" @redoCloseCallBack="onRedoClose"></rode>
      
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "../../assets/css/dialog.css";
import ZiHuiXueLooksAnswerExercise from "../template/ZiHuiXueLooksAnswerExercise.vue";
import Rode from "../template/Rode.vue";
export default {
  components: {
    ZiHuiXueLooksAnswerExercise,
    Rode,
  },
  data() {
    return {
      query: { page: 1, pageSize: 10 },
      pageTotal: 0,
      form: {},
      tabList: [{ title: "小学" }, { title: "初中" }, { title: "高中" }],
      stageList: [],
      stageIng: { name: "学段" },
      subjectList: [],
      subjectIng: { name: "学科" },
      countTotal: 0,
      errorList: [],
      newKnowledgeCodeList: [],
      mostKnowledgeCodeList: [],
      knowledgeIng: {},
      exerciseListData: [],
      dialogStatus: false,
      index: 0,
      isNull: true,
      isRedo: false,
      redoList: [],
      redoKnowledgeName: "",
    };
  },
  created() {
    this.getStageSubjectData();
    this.getUserErrorCount();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    getUserErrorCount() {
      this.getRequest("/wenjiaoopne/kc/user/question/getUserErrorCount")
        .then((result) => {
          this.countTotal = result.data || 0;
        })
        .catch(() => {});
    },
    getStageSubjectData() {
      this.getRequest("/wenjiaoopne/kc/index/bGetBStageSubject")
        .then((result) => {
          let _data = result.data;
          let _init = 0;
          this.stageList = _data;
          this.stageIng = _data[0];
          this.subjectList = _data[_init].children;
          this.subjectIng = this.subjectList[0];
          this.getErrorExercise();
          // this.getTopKnowledge();
        })
        .catch(() => {});
    },

    getTopKnowledge() {
      this.getRequest("/wenjiaoopne/kc/user/question/getTopKnowledge", {
        stage_id: this.stageIng.id,
        subject_id: this.subjectIng.id,
      }).then((result) => {
        this.mostKnowledgeCodeList = result.data.most_list;
        this.newKnowledgeCodeList = result.data.new_list;
      });
    },

    getErrorExercise() {
      this.getTopKnowledge();
      this.onLoading();
      this.getRequest(
        "/wenjiaoopne/kc/user/question/getUserErrorExercise",
        Object.assign(this.query, {
          stage_id: this.stageIng.id,
          subject_id: this.subjectIng.id,
          knowledge_id: this.knowledgeIng.knowledge_id || 0,
        })
      )
        .then((result) => {
          this.loading.close();
          this.errorList = result.data.list;
          // this.mostKnowledgeCodeList = result.data.mostKnowledgeCodeList;
          // this.newKnowledgeCodeList = result.data.newKnowledgeCodeList;
          this.mathJaxInit();
          this.isNull = this.errorList.length > 0;
          this.pageTotal = result.data.total_count || 0;
        })
        .catch(() => {});
    },
    // 切换选项卡触发事件
    onSelectTab(item) {
      this.stageIng = item;
      this.subjectList = item.children;
      this.subjectIng = this.subjectList[0];
      this.knowledgeIng = {};
      this.$set(this.query, "page", 1);
      this.getErrorExercise();
    },
    onSubject(item) {
      this.subjectIng = item;
      this.knowledgeIng = {};
      this.$set(this.query, "page", 1);
      this.getErrorExercise();
    },
    onKnowledge(item) {
      this.knowledgeIng = item;
      this.$set(this.query, "page", 1);
      this.getErrorExercise();
    },
    onRedoError(item) {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/user/question/getUserErrorExerciseAll", {
        stage_id: this.stageIng.id,
        subject_id: this.subjectIng.id,
        knowledge_id: item.knowledge_id || 0,
      })
        .then((result) => {
          this.loading.close();
          this.redoList = result.data.list;
          this.redoKnowledgeName = item.knowledge_name;
          this.isRedo = true;
        })
        .catch(() => {});
    },
    onRedoClose(result){
      this.getStageSubjectData();
      this.getUserErrorCount();
      this.isRedo = result;
    },
    onDelete(item) {
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.getRequest("/wenjiaoopne/kc/user/question/delErrorQuestion", {
            code: item.code,
          })
            .then(() => {
              this.getErrorExercise();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onExercise(item) {
      let answerArr = { A: 0, B: 1, C: 2, D: 3 };
      this.exerciseListData = [
        {
          question: item.question,
          user_answer: item.user_answer,
          user_answer_index: answerArr[item.user_answer],
          result: 0,
        },
      ];
      this.dialogStatus = true;
    },

    mathJaxInit() {
      this.$nextTick(function() {
        //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
        if (this.commonsVariable.isMathjaxConfig) {
          //判断是否初始配置，若无则配置。
          this.commonsVariable.initMathjaxConfig();
        }
        this.commonsVariable.MathQueue("question-list"); //传入组件id，让组件被MathJax渲染
      });
    },
    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getErrorExercise();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.right-container .right-header {
  position: relative;
  height: 130px;
  padding-top: 2px;
}
.subject-box {
  position: absolute;
  bottom: -10px;
  left: 0px;
  height: 40px;
}
.subject-list {
  display: inline-block;
  width: 80px;
  text-align: center;
  line-height: 35px;
  height: 35px;
  font-size: 12px;
  margin-right: 9px;
  background-color: #ebf7fe;
  color: #7a8aa3;
}
.subjectEd {
  background-color: #f9bb00 !important;
  color: #fff !important;
}
.subject-list:hover {
  background-color: #f9bb00;
  color: #fff;
}
.knowledge-box {
  padding-top: 20px;
}
.dialog-looks-Answer {
  max-height: 700px;
  overflow: auto;
}
.right-container .sign {
  width: 123px;
  height: 49px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/3.png");
  color: #fff;
}
.right-container .sign {
  margin-right: 10px;
}
.right-container .active {
  background-image: url("../../assets/images/2.png");
}
.right-container .right-header-text {
  color: #bcc8dd;
  margin-left: 10px;
}
.right-container .num {
  display: inline-block;
  color: #40b8ee;
}

.right-container .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 2px;
  background-color: #40b8ee;
  vertical-align: middle;
}

.right-container .knowledge {
  width: 443px;
  color: #7a8aa3;
  font-size: 14px;
  height: 90px;
  background-color: #ebf7fe;
}
.right-container .knowledge-title {
  position: relative;
  height: 70px;
  margin-left: 10px;
}
.right-container .knowledge-scrollbars {
  height: 70px;
  width: 316px;
  overflow-y: auto;
  overflow-x: hidden;
}
.right-container .knowledge-list {
  width: 327px;
  margin: 4px 0;
  color: #40b8ee;
}
.right-container .knowledge-text {
  width: 155px;
  margin-left: 5px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.knowledge-button {
  width: 200px;
}
.right-container .knowledge-looks-error {
  padding: 3px 8px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #40b8ee;
  color: #fff;
  font-size: 10px;
  cursor: pointer;
}
.top-img {
  position: absolute;
  width: 105px;
  bottom: 12%;
  left: 2%;
}
.redo-error {
  padding: 3px 8px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #bc4654;
  color: #fff;
  font-size: 10px;
  cursor: pointer;
}

.right-container .count-box {
  color: #7a8aa3;
  padding: 5px 0;
  font-size: 14px;
}
.right-container .count-box .text-color {
  color: #40b8ee;
}
.right-container .list-container {
  min-height: 280px;
  color: #7a8aa3;
  font-size: 14px;
}
.right-container .error-list {
  height: 90px;
  background-color: #ebf7fe;
  margin: 5px 0;
}
.right-container .error-list-left {
  width: 635px;
  padding: 0 15px;
  height: 57px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.right-container .error-list-right {
  width: 160px;
  color: #fff;
  font-size: 16px;
}
.right-container .error-list-right .error-list-right-top {
  padding: 17px 0;
  text-align: center;
  background-color: #40b8ee;
  cursor: pointer;
}
.right-container .error-list-right .error-list-right-bottom {
  padding: 7px 0;
  text-align: center;
  background-color: #bc4654;
  cursor: pointer;
}
.list-page {
  width: 100%;
  text-align: right;
  padding: 10px 0;
}
.dialog-exercise .exercise-content {
  min-height: 250px;
  max-height: 460px;
  overflow-y: auto;
  color: #000;
}
.dialog-exercise .title {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.dialog-exercise .title .title-item {
  width: 30px;
  height: 30px;
  background-color: #b1b1b1;
  margin: 0 10px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-exercise .stem {
  padding-bottom: 20px;
}
.dialog-exercise .explain-box {
  margin-top: 20px;
}
.dialog-exercise .explain {
  margin-top: 5px;
}
.dialog-exercise .options {
  position: relative;
}
.dialog-exercise .item {
  margin: 4px 0;
  min-width: 742px;
  display: inline-block;
  padding: 10px 5px;
  /* background-color: aliceblue; */
}
.dialog-exercise .item:hover {
  box-shadow: 0px 1px 10px #f0f0f0;
}
.dialog-exercise .footer {
  margin-top: 10px;
  width: 100%;
  text-align: center;
}
.dialog-exercise .footer .tip {
  margin-top: 20px;
  font-size: 12px;
}
.m-10 {
  margin: 0 10px;
}
.success {
  background-color: #2ea599;
  color: #fff;
}
.error {
  background-color: #cc3f39;
  color: #fff;
}
</style>
